<template>
	<div class="notifications" style="margin-right: 40px">
		<el-popover v-if="$route.params.workflowId || $route.path.includes('/admin')" placement="right" width="350"
			trigger="click">
			<el-date-picker style="width: 100%; margin-top: 10px" :format="dateDisplayFormat" @change="retrieve(false)"
				:clearable="false" class="dateSelect" v-model="dateSelectValue" type="date"
				placeholder="View logs by day"></el-date-picker>
			<el-pagination :small="true" :pager-count="5" :page-sizes="[10, 20, 50]" @current-change="retrieve(false)"
				@size-change="retrieve(false)" style="padding-left: 0px; margin-left: -5px; margin-top: 10px" background
				:page-size.sync="pageSize" layout="sizes, prev, pager, next" :total="totalRecords"
				:current-page.sync="currentPage">
			</el-pagination>
			<el-divider class="compressedDivider"></el-divider>
			<div v-loading="loading">
				<div class="panel">
					<ul>
						<li :key="i" v-for="(notification, i) in notifications">
							<div>
								<el-avatar :style="{
									backgroundColor: returnColor(notification.username),
									fontWeight: 'bold',
									fontSize: '18px',
								}" class="avatar">{{ notification.username.charAt(0).toUpperCase() }}</el-avatar>
							</div>
							<h4 class="notifcation">{{ notification.verboseLog }}</h4>
							<span class="date">{{ returnTimeDifference(notification.timestamp) }}</span>
						</li>
					</ul>
					<el-empty :image="require('../assets/empty.svg')" v-if="!notifications.length"
						description="No Logs"></el-empty>
				</div>
			</div>
			<el-badge slot="reference" :hidden="notificationLength === 0" :value="notificationLength" type="danger">
				<i @click="
					() => {
						notificationLength = 0;
					}
				" style="font-size: 25px; cursor: pointer" class="el-icon-bell"></i>
			</el-badge>
		</el-popover>
	</div>
</template>

<script>
import { returnColor } from "../utils/general.js";
import { timeDifference } from "../utils/time.js";
export default {
	data() {
		return {
			notifications: [],
			loading: false,
			dateSelectValue: "",
			dateDisplayFormat: "",
			notificationLength: 0,
			totalRecords: 0,
			currentPage: 1,
			pageSize: 10,
		};
	},
	async beforeMount() {
		const workflowId =
			typeof this.$route.params.workflowId === "string"
				? this.$route.params.workflowId.trim()
				: "";

		const isAdminRoute = this.$route.path.includes("/admin");

		if (workflowId || isAdminRoute) {
			this.dateSelectValue = new Date();
			this.retrieve(true);
		}
	},
	methods: {
		returnColor(string) {
			return returnColor(string);
		},
		async retrieve(mounted) {
			this.dateDisplayFormat = "dd/MM/yyyy";
			this.loading = true;
			let queryDate = new Date(this.dateSelectValue);
			if (!mounted) {
				queryDate.setDate(queryDate.getDate() + 1);
				queryDate.setHours(-1, 0, 0, 0);
			}
			const beginningOfDate = queryDate.toISOString().split("T")[0];
			let nextDay = new Date(beginningOfDate);
			nextDay.setDate(nextDay.getDate() + 1);
			nextDay = new Date(nextDay);
			nextDay = nextDay.toISOString().split("T")[0];
			const result = await this.httpHelper("RUNTIME", "GET", "logs/returnAuditLogs", {
				workflowId: this.$route.params.workflowId,
				datesAfter: beginningOfDate,
				datesBefore: nextDay,
				resultsPerPage: this.pageSize,
				page: this.currentPage - 1,
			});
			setTimeout(() => {
				this.loading = false;
				if (!result?.error) {
					this.notifications = result.response.logs;
					this.totalRecords = result.response.totalRecords;
					this.notificationLength = this.totalRecords;
				} else {
					this.$notifyError(this, result.error);
				}
			}, 500);
		},
		returnTimeDifference(date) {
			return timeDifference(new Date(), new Date(date));
		},
	},
};
</script>

<style scoped>
.notifications /deep/ .el-badge__content.is-fixed {
	transform: translateY(-50%) translateX(105%) !important;
}

.notifications /deep/ .el-input__inner {
	height: 40px !important;
	line-height: 40px !important;
}

.panel /deep/ .el-empty {
	padding-top: 0px !important;
}

.compressedDivider {
	margin-bottom: 0px !important;
	margin-top: 10px !important;
}

li {
	list-style: none;
	display: flex;
	position: relative;
	margin-bottom: 30px;
}

.notifcation {
	margin: 0;
	margin-left: 20px;
	display: list-item;
	max-width: 320px;
	margin-bottom: 15px;
	text-align: left;
	word-break: break-word;
	margin-bottom: 10px;
}

.avatar {
	display: inline-block;
}

ul {
	margin: 0;
	padding: 0;
	margin-bottom: 10px;
}

.date {
	font-weight: bold;
	font-size: 10px;
	position: absolute;
	bottom: -10px;
	left: 60px;
	word-break: break-word;
}

.panel {
	max-height: 500px;
	overflow: hidden;
	overflow-y: scroll;
	padding-left: 20px;
	padding-right: 20px;
	padding-top: 20px;
}
</style>
